import { createReducer } from '@reduxjs/toolkit';
import {
    toggleOrderIdCollapsible,
    clearOrderCollapsible,
    clearGoodsCollapsible,
    toggleGoodsIdCollapsible,
    clearDemandOrderCollapsible,
    clearGeneralReturnOrderCollapsible,
    clearPurchaseOrderCollapsible,
    toggleDemandOrderIdCollapsible,
    toggleGeneralReturnOrderIdCollapsible,
    togglePurchaseOrderIdCollapsible,
} from '../actions/collapsibleOpenStateActions';

export interface CollapsibleOpenState {
    ordersIds: number[];
    purchaseOrdersIds: number[];
    generalReturnOrdersIds: number[];
    demandOrdersIds: number[];
    goodsIds: number[];
}

export const collapsibleOpenStateReducer = createReducer<CollapsibleOpenState>(
    { ordersIds: [], purchaseOrdersIds: [], generalReturnOrdersIds: [], demandOrdersIds: [], goodsIds: [] },
    (builder) => {
        builder
            .addCase(toggleOrderIdCollapsible, (state: CollapsibleOpenState, action: any) => {
                const orderId = action.payload;

                if (!orderId || !state.ordersIds) {
                    return;
                }

                const orderIndex = state.ordersIds?.findIndex((oId) => oId === orderId);

                if (orderIndex !== undefined && orderIndex >= 0) {
                    state.ordersIds.splice(orderIndex, 1);
                } else {
                    state.ordersIds.push(orderId);
                }
            })
            .addCase(clearOrderCollapsible, (state: CollapsibleOpenState, action: any) => {
                state.ordersIds = [];
            })
            .addCase(togglePurchaseOrderIdCollapsible, (state: CollapsibleOpenState, action: any) => {
                const orderId = action.payload;

                if (!orderId || !state.purchaseOrdersIds) {
                    return;
                }

                const orderIndex = state.purchaseOrdersIds?.findIndex((oId) => oId === orderId);

                if (orderIndex !== undefined && orderIndex >= 0) {
                    state.purchaseOrdersIds.splice(orderIndex, 1);
                } else {
                    state.purchaseOrdersIds.push(orderId);
                }
            })
            .addCase(clearPurchaseOrderCollapsible, (state: CollapsibleOpenState, action: any) => {
                state.purchaseOrdersIds = [];
            })
            .addCase(toggleDemandOrderIdCollapsible, (state: CollapsibleOpenState, action: any) => {
                const orderId = action.payload;

                if (!orderId || !state.demandOrdersIds) {
                    return;
                }

                const orderIndex = state.demandOrdersIds?.findIndex((oId) => oId === orderId);

                if (orderIndex !== undefined && orderIndex >= 0) {
                    state.demandOrdersIds.splice(orderIndex, 1);
                } else {
                    state.demandOrdersIds.push(orderId);
                }
            })
            .addCase(clearDemandOrderCollapsible, (state: CollapsibleOpenState, action: any) => {
                state.demandOrdersIds = [];
            })
            .addCase(toggleGeneralReturnOrderIdCollapsible, (state: CollapsibleOpenState, action: any) => {
                const orderId = action.payload;

                if (!orderId || !state.generalReturnOrdersIds) {
                    return;
                }

                const orderIndex = state.generalReturnOrdersIds?.findIndex((oId) => oId === orderId);

                if (orderIndex !== undefined && orderIndex >= 0) {
                    state.generalReturnOrdersIds.splice(orderIndex, 1);
                } else {
                    state.generalReturnOrdersIds.push(orderId);
                }
            })
            .addCase(clearGeneralReturnOrderCollapsible, (state: CollapsibleOpenState, action: any) => {
                state.generalReturnOrdersIds = [];
            })
            .addCase(toggleGoodsIdCollapsible, (state: CollapsibleOpenState, action: any) => {
                const goodsId = action.payload;

                if (!goodsId || !state.goodsIds) {
                    return;
                }

                const goodsIndex = state.goodsIds?.findIndex((oId) => oId === goodsId);

                if (goodsIndex !== undefined && goodsIndex >= 0) {
                    state.goodsIds.splice(goodsIndex, 1);
                } else {
                    state.goodsIds.push(goodsId);
                }
            })
            .addCase(clearGoodsCollapsible, (state: CollapsibleOpenState, action: any) => {
                state.goodsIds = [];
            });
    },
);
